import { type FC, type ReactNode, useId } from "react";

import { Label } from "@/components/_atoms/label";
import { RadioGroup, RadioGroupItem } from "@/components/_atoms/radio-group";
import { cn } from "@/lib/cn";

export interface RadioOption {
  value: string;
  label: string;
  icon?: ReactNode;
}

interface OptionRadioGroupProps {
  value: string;
  onValueChange: (value: string) => void;
  options: RadioOption[];
  className?: string;
}

export const OptionRadioGroup: FC<OptionRadioGroupProps> = ({ value, onValueChange, options, className }) => {
  const id = useId();

  return (
    <RadioGroup
      value={value}
      onValueChange={onValueChange}
      className={cn("space-y-2 py-1", className)}
      onKeyDown={(e) => e.stopPropagation()}
    >
      {options.map((option) => (
        <div key={option.value} className="flex items-center space-x-2">
          <RadioGroupItem value={option.value} id={`${id}-${option.value}`} />
          {option.icon && <span className="text-muted-foreground">{option.icon}</span>}
          <Label htmlFor={`${id}-${option.value}`} className="font-normal">{option.label}</Label>
        </div>
      ))}
    </RadioGroup>
  );
};
